const TeacherIdProfileCard = ({
  teacherData,
  handleConfirmTeacherDetail,
  handleCancelTeacherDetail,
}) => {
  const teacher = teacherData?.[0];

  const teacherProfileData = [
    { label: "Teacher ID", value: teacher?.TeacherID },
    { label: "Teacher Name", value: teacher?.TeacherName },

    { label: "D.O.B", value: teacher?.DOB },
    { label: "Gender", value: teacher?.GENDER },

    { label: "Mobile Number", value: teacher?.MobileNumber },
    {
      label: "Whatsapp Number",
      value: teacher?.WhatsappNumber || "-",
    },

    { label: "Email ID", value: teacher?.EmailId },
    { label: "School UDISE", value: teacher?.School_UDISE },

    { label: "School Name", value: teacher?.SCHNAME },
    { label: "State", value: teacher?.State },

    { label: "District", value: teacher?.District },
    { label: "Block/Zone", value: teacher?.Block_Zone },

    { label: "Cluster Name", value: teacher?.ClusterName },
  ];

  return (
    <div>
      <div className="bg-[#e9ebfa] flex items-center justify-center p-4">
        <div className="w-full max-w-4xl bg-white rounded-2xl shadow-sm border border-gray-100 p-2 md:p-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-6 gap-x-12">
            {teacherProfileData.map((item) => (
              <div key={item.label}>
                <p className="text-sm text-gray-400 mb-1">{item.label}</p>
                <p className="text-base md:text-lg text-gray-900 font-medium break-words">
                  {item.value || "-"}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div>
        <h2>Please confirm the details once again</h2>
        <div className="flex justify-center gap-4 w-[100%]">
          <button
            className="bg-gradient-to-r from-[#E7EAFF] to-[#E7EAFF] text-[#3C57AD] px-[40px] py-[10px] rounded-[10px] mt-[20px] text-center flex flex-row justify-center"
            onClick={() => handleCancelTeacherDetail()}
          >
            No
          </button>
          <button
            className="bg-gradient-to-r from-[#2C3EA2] to-[#192867] text-[#fff] px-[40px] py-[10px] rounded-[10px] mt-[20px] text-center flex flex-row justify-center"
            onClick={() => {
              handleConfirmTeacherDetail();
            }}
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  );
};

export default TeacherIdProfileCard;
